export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Есептен шығаруға жалпы сома"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Комиссия"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ақпарат"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Есептеуге"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Соманы есептеу мүмкін емес"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Төлем жасау үшін қаражат жеткіліксіз"])}
}